import React, { ReactNode } from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import {
  IGroup,
  ILevel,
} from "~/pages/Editor/EditorCatalogEducationalPrograms/types";

export const getCurriculumColumns =
  (i18nPrefix: string) =>
  (t: TFunction, options: string[]): ColumnsType<IGroup | ILevel> =>
    options.map((option) => ({
      title: t(`${i18nPrefix}.${option}`),
      dataIndex: option,
      key: option,
      render: (value: ReactNode) => <span>{value}</span>,
    }));
